import React from "react"
import UAI from "./UAI"
import { FiEye, FiEyeOff, FiCheck, FiX } from "react-icons/fi"
import { BiLineChart } from "react-icons/bi"
import facultades from "./data/facultades.json"
import { Link } from "react-router-dom"
import { FaCalendar, FaRegFilePdf, FaUserGraduate } from "react-icons/fa"
import log from "loglevel"
import PopOverDatosEncuesta from "./sgc/PopOverDatosEncuesta"
import EditarBenchmark from "./Utils/EditarBenchmark"
import { Form, Table } from "react-bootstrap"
import { isNumber } from "lodash"

class atributos {
  static displayatributos = {
    facultades_secundarias: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte.facultades_secundarias &&
          cohorte.facultades_secundarias !== ""
        ) {
          let parsed = null
          try {
            parsed = JSON.parse(cohorte.facultades_secundarias)
          } catch (e) {
            return <>-</>
          }
          return (
            <ul>
              {parsed.map((f, idx) => (
                <li key={idx}>{f.text}</li>
              ))}
            </ul>
          )
        } else {
          return <>-</>
        }
      },
    },
    ventas_por_periodo: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["ventas_por_periodo"] === undefined ||
          cohorte["ventas_por_periodo"] === null ||
          cohorte["ventas_por_periodo"] === ""
        ) {
          return ""
        }
        let pagoprofesores = null
        try {
          pagoprofesores = JSON.parse(
            cohorte["ventas_por_periodo"].replace(":NaN,", ':"",')
          )
        } catch (e) {
          pagoprofesores = null
          return (
            <div className="alert-danger">
              Datos inválidos:{cohorte["ventas_por_periodo"]}
            </div>
          )
        }
        if (
          !pagoprofesores ||
          !pagoprofesores.ventas ||
          pagoprofesores.ventas.length <= 0
        ) {
          return ""
        }
        const nf = new Intl.NumberFormat("es-CL", {
          style: "currency",
          currency: "CLP",
          maximumFractionDigits: 0,
          roundingIncrement: 5,
        })
        const df = new Intl.DateTimeFormat("es-CL", {
          day: "numeric",
          month: "short",
          year: "2-digit",
        })
        return (
          <ul>
            {pagoprofesores.ventas.map((ventaperiodo, idx) => {
              let fechaInicio = new Date(
                Date.parse(ventaperiodo.fecha_inicio + " GMT-4")
              )
              let fechaFin = new Date(
                Date.parse(ventaperiodo.fecha_fin + " GMT-4")
              )
              let periodo =
                isNaN(fechaInicio) || isNaN(fechaFin)
                  ? "Fecha inválida"
                  : df.format(fechaInicio) + " - " + df.format(fechaFin)
              let cssPeriodo =
                isNaN(fechaInicio) || isNaN(fechaFin) ? " alert-danger" : ""
              return (
                <li key={idx}>
                  <Table>
                    <tbody>
                      <tr>
                        <th>Período</th>
                        <td>Cohorte</td>
                        <td className={"text-end" + cssPeriodo}>{periodo}</td>
                      </tr>
                      {ventaperiodo.Profesores.map((profesor, idx2) => {
                        let subCohorte = usuario.cohortes[profesor["Cohorte"]]
                        let tieneSubCohorte =
                          (cohorte.gradoid === 1 || cohorte.gradoid === 10) &&
                          subCohorte
                        let nombreSubCohorte = tieneSubCohorte
                          ? subCohorte.nombre
                          : "-"
                        if (Array.isArray(profesor["Nombre Profesor"])) {
                          let totales = profesor.Total.toString().split(";")
                          return profesor["Nombre Profesor"].map((p2, idx3) => {
                            let total = null
                            try {
                              total = parseInt(totales[idx3])
                            } catch (e) {
                              total = 0
                              return (
                                <tr
                                  key={idx2 + "-" + idx3}
                                  className="alert-danger"
                                >
                                  <td>{p2}</td>
                                  <td>{nombreSubCohorte}</td>
                                  <td className="text-end">
                                    Dato inválido:{profesor.Total}
                                  </td>
                                </tr>
                              )
                            }
                            return (
                              <tr key={idx2 + "-" + idx3}>
                                <td>{p2}</td>
                                <td>{nombreSubCohorte}</td>
                                <td className="text-end">{nf.format(total)}</td>
                              </tr>
                            )
                          })
                        } else {
                          let total = null
                          try {
                            total = profesor.Total.toFixed(0)
                          } catch (e) {
                            total = 0
                            return (
                              <tr key={idx2} className="alert-danger">
                                <td>{profesor["Nombre Profesor"]}</td>
                                <td>{profesor["Cohorte"]}</td>
                                <td className="text-end">
                                  Dato inválido:{profesor.Total}
                                </td>
                              </tr>
                            )
                          }
                          return (
                            <tr key={idx2}>
                              <td>{profesor["Nombre Profesor"]}</td>
                              <td>{profesor["Cohorte"]}</td>
                              <td className="text-end">{nf.format(total)}</td>
                            </tr>
                          )
                        }
                      })}
                      <tr>
                        <th>Subtotal período</th>
                        <td>&nbsp;</td>
                        <td className="text-end">
                          {nf.format(ventaperiodo.Total)}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </li>
              )
            })}
          </ul>
        )
      },
    },
    profesores_nucleo: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["profesores_nucleo"] === undefined ||
          cohorte["profesores_nucleo"] === null ||
          cohorte["profesores_nucleo"] === ""
        ) {
          return ""
        }
        let profesores = null
        try {
          profesores = JSON.parse(cohorte["profesores_nucleo"])
        } catch (e) {
          log.warn(e)
        }
        if (!profesores || profesores.length === 0) {
          return ""
        }
        return (
          <ul>
            {profesores.map((profesor, idx) => (
              <li key={idx}>
                {profesor.text} {profesor.id}
              </li>
            ))}
          </ul>
        )
      },
    },
    usuario_coordinador_admision: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["NombreCoordinadorAdmision"] &&
          cohorte["NombreCoordinadorAdmision"].length > 0 &&
          !cohorte.esborrador
        ) {
          return cohorte["NombreCoordinadorAdmision"]
        } else {
          return cohorte["usuario_coordinador_admision"]
        }
      },
    },
    coordinador_academico: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["NombreCoordinadorAcademico"] &&
          cohorte["NombreCoordinadorAcademico"].length > 0 &&
          !cohorte.esborrador
        ) {
          return cohorte["NombreCoordinadorAcademico"]
        } else {
          return cohorte["coordinador_academico"]
        }
      },
    },
    precio: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        let options = {
          style: "currency",
          maximumFractionDigits: 2,
          minimumFractionDigits: 0,
        }
        if (parseInt(cohorte["id_tipo_moneda_precio"]) === 3) {
          options.currency = "CLF"
        } else {
          options.currency = "CLP"
        }
        let matricula = parseInt(cohorte["precio_matricula"], 10)
        matricula = matricula
          .toLocaleString("es-CL", options)
          .replace(/CLF/, "UF")
        let arancel =
          matricula > 0
            ? parseInt(cohorte["precio"], 10) -
              parseInt(cohorte["precio_matricula"], 10)
            : parseInt(cohorte["precio"], 10)
        arancel = arancel.toLocaleString("es-CL", options).replace(/CLF/, "UF")
        if (highlight) {
          arancel = UAI.highlight(arancel, highlight)
          matricula = UAI.highlight(matricula, highlight)
        }
        let output = (
          <div>
            <span className="precio-arancel">Arancel: {arancel}</span>
            {matricula > 0 && (
              <span className="precio-matricula">Matrícula: {}</span>
            )}
          </div>
        )
        return output
      },
    },
    programa_id: {
      editable: false,
    },
    programa_id_anterior: {
      display: (cohorte, periodo, highlight = undefined, usuario) => {
        console.log("Display de benchmark!")
        if (cohorte.benchmarkinfo) {
          return cohorte.benchmarkinfo.nombre
        }
        let benchmarkid = cohorte["programa_id_anterior"]
        if (!benchmarkid || benchmarkid < 1) {
          return "-"
        }
        let benchmark = usuario.cohortes[benchmarkid]
        if (!benchmark) {
          return "" + benchmarkid
        }
      },
      input: (cohorte) => {
        return <EditarBenchmark cohorte={cohorte} />
      },
    },
    precio_postulacion: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (!cohorte["acepta_pago_postulacion"]) {
          return " - "
        }
        let options = {
          style: "currency",
          maximumFractionDigits: 2,
          minimumFractionDigits: 0,
        }
        if (parseInt(cohorte["id_tipo_moneda_postulacion"]) === 3) {
          options.currency = "CLF"
        } else {
          options.currency = "CLP"
        }
        let preciopostulacion = parseInt(cohorte["precio_postulacion"], 10)
        let output = preciopostulacion
          .toLocaleString("es-CL", options)
          .replace(/CLF/, "UF")
        if (highlight) {
          output = UAI.highlight(output, highlight)
        }
        return output
      },
    },
    fecha_ingreso_sence: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        let val = new Date(Date.parse(cohorte["fecha_ingreso_sence"]))
        if (typeof val === "object" && !isNaN(val)) {
          val = val.toLocaleDateString("es-CL", {
            month: "2-digit",
            year: "2-digit",
            day: "2-digit",
          })
          if (highlight) {
            val = UAI.highlight(val, highlight)
          }
          return val
        } else {
          return cohorte["fecha_ingreso_sence"]
        }
      },
    },
    fecha_vigencia_sence: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        let val = new Date(Date.parse(cohorte["fecha_vigencia_sence"]))
        if (typeof val === "object" && !isNaN(val)) {
          val = val.toLocaleDateString("es-CL", {
            month: "2-digit",
            year: "2-digit",
            day: "2-digit",
          })
          if (highlight) {
            val = UAI.highlight(val, highlight)
          }
          return val
        } else {
          return cohorte["fecha_vigencia_sence"]
        }
      },
    },
    fecha_inicio: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        let val = new Date(Date.parse(cohorte["fecha_inicio"]))
        if (typeof val === "object") {
          val = val.toLocaleDateString("es-CL", {
            month: "2-digit",
            year: "2-digit",
            day: "2-digit",
          })
          if (highlight) {
            val = UAI.highlight(val, highlight)
          }
          return val
        } else {
          return cohorte["fecha_inicio"]
        }
      },
    },
    fecha_termino: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        let val = new Date(Date.parse(cohorte["fecha_termino"]))
        if (typeof val === "object") {
          val = val.toLocaleDateString("es-CL", {
            month: "2-digit",
            year: "2-digit",
            day: "2-digit",
          })
          if (highlight) {
            val = UAI.highlight(val, highlight)
          }
          return val
        } else {
          return cohorte["fecha_termino"]
        }
      },
    },
    disponibilidad: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (cohorte["disponibilidad"] === "Visible") {
          return <FiEye />
        } else {
          return <FiEyeOff />
        }
      },
    },
    documentos_requeridos: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        let documentos = cohorte.documentos_requeridos
          ? cohorte.documentos_requeridos.split(",")
          : []
        if (documentos.length === 0) {
          return <></>
        }
        return (
          <ul>
            {documentos.map((documentoid, idx) => {
              let documento = UAI.tiposDocumentos.find((doc) => {
                return doc.TipoDocumentoId === parseInt(documentoid)
              })
              if (!documento) return <li key={idx}>{documentoid}</li>
              return <li key={idx}>{documento.Nombre}</li>
            })}
          </ul>
        )
      },
    },
    programaid_anterior: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        let benchmarkid = cohorte["programaid_anterior"]
        let output = ""
        if (usuario.cohortes[benchmarkid]) {
          output = usuario.cohortes[benchmarkid].nombre
        } else {
          output = benchmarkid
        }
        return output
      },
      displaymobile: function (
        cohorte,
        periodo,
        highlight = undefined,
        usuario
      ) {
        let output = ""
        if (usuario.cohortes[cohorte["programaid_anterior"]]) {
          output = usuario.cohortes[cohorte["programaid_anterior"]].sigla
        } else {
          output = cohorte["programaid_anterior"]
        }
        return output
      },
    },
    id: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        let output = cohorte.id
        if (highlight) {
          output = UAI.highlight(output, highlight)
        }
        return output
      },
      editable: false,
    },
    sigla_interna: {
      editable: false,
    },
    programa_padre_id: {
      editable: false,
      tipo: "Texto"
    },
    gradoid: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        let output = UAI.nombresGrados[cohorte.gradoid]
        if (highlight) {
          output = UAI.highlight(output, highlight)
        }
        return output
      },
      displaymobile: function (
        cohorte,
        periodo,
        highlight = undefined,
        usuario
      ) {
        if (!UAI.nombresGrados[cohorte.gradoid]) {
          return cohorte.gradoid
        }
        let output = UAI.nombresGrados[cohorte.gradoid].slice(0, 3)
        if (highlight) {
          output = UAI.highlight(output, highlight)
        }
        return output
      },
      editable: false,
    },
    facultad_id: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        let facultad = Object.values(facultades).find((value) => {
          return value.id === cohorte.facultad_id
        })
        if (!facultad) {
          log.error(
            "Cohorte " +
              cohorte.id +
              " con facultad inválida " +
              cohorte.facultad_id
          )
          log.debug(cohorte)
          return ""
        }
        let output = facultad.nombre
        if (highlight) {
          output = UAI.highlight(output, highlight)
        }
        return output
      },
      displaymobile: function (
        cohorte,
        periodo,
        highlight = undefined,
        usuario
      ) {
        let output = Object.values(facultades).find((value) => {
          return value.id === cohorte.facultad_id
        }).nombrecorto
        if (highlight) {
          output = UAI.highlight(output, highlight)
        }
        return output
      },
      editable: false,
      input: (cohorte) => {
        return (
          <Form.Select size="sm" disabled defaultValue={cohorte.facultad_id}>
            <option value="">Seleccione Facultad</option>
            {Object.values(facultades).map((f) => (
              <option key={f.id} value={f.id}>
                {f.nombre}
              </option>
            ))}
          </Form.Select>
        )
      },
    },
    sede_id: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        let sedeid = parseInt(cohorte["sede_id"])
        let output = null
        if (sedeid === 1) {
          output = "Viña del Mar"
        } else if (sedeid === 2) {
          output = "Presidente Errázuriz"
        } else if (sedeid === 3) {
          output = "Peñalolén"
        } else if (sedeid === 4) {
          output = "Vitacura"
        } else if (sedeid === 5) {
          output = "Otra: " + cohorte["LugarWeb"]
        } else {
          output = cohorte["sede_id"]
        }

        if (highlight) {
          output = UAI.highlight(output, highlight)
        }
        return output
      },
      displaymobile: function (
        cohorte,
        periodo,
        highlight = undefined,
        usuario
      ) {
        let output = null
        if (cohorte["sede_id"] === "1") {
          output = "Viña"
        } else if (cohorte["sede_id"] === "2") {
          output = "Erráz"
        } else if (cohorte["sede_id"] === "3") {
          output = "Peña"
        } else if (cohorte["sede_id"] === "4") {
          output = "S.María"
        } else if (cohorte["sede_id"] === "5") {
          output = cohorte["lugar"]
        }
        if (highlight) {
          output = UAI.highlight(output, highlight)
        }
        return output
      },
    },
    Folleto: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (cohorte["Folleto"] === null || cohorte["Folleto"] === undefined) {
          return ""
        } else {
          return <a href={cohorte["Folleto"]}>Ver</a>
        }
      },
    },
    imagen: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (cohorte["imagen"] === null || cohorte["imagen"] === undefined) {
          return ""
        } else {
          return (
            <img src={cohorte["imagen"]} height="50px" alt={cohorte.nombre} />
          )
        }
      },
    },
    nucleo_programa: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          !cohorte["parsed_nucleo_programa"] ||
          cohorte["parsed_nucleo_programa"] === ""
        ) {
          return ""
        }
        return (
          <ul>
            {cohorte["parsed_nucleo_programa"].map((miembro, idx) => (
              <li key={idx} className="text-capitalize">
                {miembro.text.toLowerCase()}
              </li>
            ))}
          </ul>
        )
      },
    },
    comite_academico_programa: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          !cohorte["parsed_comite_academico_programa"] ||
          cohorte["parsed_comite_academico_programa"] === ""
        ) {
          return ""
        }
        return (
          <ul>
            {cohorte["parsed_comite_academico_programa"].map((miembro, idx) => (
              <li key={idx} className="text-capitalize">
                {miembro.text.toLowerCase()}
              </li>
            ))}
          </ul>
        )
      },
    },
    area_tematica_multiple: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["area_tematica_multiple"] === undefined ||
          cohorte["area_tematica_multiple"] === null ||
          cohorte["area_tematica_multiple"] === ""
        ) {
          return ""
        }
        let areas = null
        try {
          areas = JSON.parse(cohorte["area_tematica_multiple"])
        } catch (e) {
          log.warn(e)
        }
        if (!areas || areas.length === 0) {
          return ""
        }
        return (
          <ul>
            {areas.map((area, idx) => (
              <li key={idx}>
                {highlight
                  ? UAI.highlight(area.Nombre, highlight)
                  : area.Nombre}
              </li>
            ))}
          </ul>
        )
      },
    },
    centrocosto: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (isNumber(cohorte.centrocosto)) {
          return cohorte.centrocosto
        } else if (cohorte.centrocosto) {
          let cc = parseInt(cohorte.centrocosto)
          return cc
        } else {
          return "-"
        }
      },
    },
    encuesta_docente: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        return (
          <PopOverDatosEncuesta cohorte={cohorte} encuesta="encuesta_docente" />
        )
      },
    },
    encuesta_general_satisfaccion: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        return (
          <PopOverDatosEncuesta
            cohorte={cohorte}
            encuesta="encuesta_general_satisfaccion"
          />
        )
      },
    },
    encuesta_admision: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        return (
          <PopOverDatosEncuesta
            cohorte={cohorte}
            encuesta="encuesta_admision"
          />
        )
      },
    },
    encuesta_salida_programa: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        return (
          <PopOverDatosEncuesta
            cohorte={cohorte}
            encuesta="encuesta_salida_programa"
          />
        )
      },
    },
    encuesta_inicio: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        return (
          <PopOverDatosEncuesta cohorte={cohorte} encuesta="encuesta_inicio" />
        )
      },
    },
    contenidos_detallados: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["contenidos_detallados"] === undefined ||
          cohorte["contenidos_detallados"] === null ||
          cohorte["contenidos_detallados"].trim().length === 0
        ) {
          return ""
        }
        // Fix trailing comma
        let clases = cohorte["contenidos_detallados"].replace(/},]}/g, "}]}")
        try {
          clases = JSON.parse(clases)
        } catch (e) {
          console.log("Error parsing clases")
          console.log(cohorte["contenidos_detallados"])
          console.log(e)
          return "Error!"
        }
        let titulo = clases.Titulo
        if (
          clases.Titulo === undefined ||
          clases["Contenidos por clase o módulo"].length === 0
        ) {
          return ""
        }
        clases = clases["Contenidos por clase o módulo"]
        let _clases = []
        let i = 0
        clases.forEach((clase) => {
          i++
          let _contenidos = (
            <ul>
              {clase["Listado de contenidos"]
                .split("\n")
                .map((contenido, index) => (
                  <li key={index}>{contenido}</li>
                ))}
            </ul>
          )
          _clases.push({ titulo: clase.Título, contenidos: _contenidos, n: i })
        })
        return (
          <div className="contenidos_detallados">
            <table className="table table-sm table-bordered">
              <thead className="thead-light">
                <tr>
                  <th>#</th>
                  <th className="contenidos_detallados_titulo">{titulo}</th>
                  <th className="contenidos_detallados_contenidos">
                    Contenidos
                  </th>
                </tr>
              </thead>
              <tbody>
                {_clases.map((clase, index) => (
                  <tr key={index}>
                    <td>{clase.n}</td>
                    <td>
                      {highlight
                        ? UAI.highlight(clase.titulo, highlight)
                        : clase.titulo}
                    </td>
                    <td>
                      {highlight
                        ? UAI.highlight(clase.contenidos, highlight)
                        : clase.contenidos}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      },
    },
    metas_mensuales: {
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (!cohorte["metas_mensuales"]) {
          return ""
        }
        // Fix trailing comma
        let metas = cohorte["metas_mensuales"].replace(/},]}/g, "}]}")
        try {
          metas = JSON.parse(metas)
        } catch (e) {
          console.log("Error parsing metas mensuales")
          console.log(cohorte["metas_mensuales"])
          console.log(e)
          return "Error!"
        }
        if (metas.metas === undefined || metas.metas.length === 0) {
          return ""
        }
        metas = metas.metas
        return (
          <table className="table table-sm table-bordered">
            <thead className="thead-light">
              <tr>
                <th>&nbsp;</th>
                {metas.map((meta, index) => (
                  <th key={cohorte.id + "-" + meta.Mes + "-th-" + index}>
                    {meta.Mes.slice(0, 1)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span title="Postulantes">P</span>
                </td>
                {metas.map((meta, index) => (
                  <td key={cohorte.id + "-" + meta.Mes + "-p-" + index}>
                    {meta.Postulantes}
                  </td>
                ))}
              </tr>
              <tr>
                <td>
                  <span title="Matriculados">M</span>
                </td>
                {metas.map((meta, index) => (
                  <td key={cohorte.id + "-" + meta.Mes + "-m-" + index}>
                    {meta.Matriculados}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        )
      },
    },
  }
  static atributossinteticos = {
    ventas_por_periodo_raw: {
      Codigo: "ventas_por_periodo_raw",
      Nombre: "Pago profesores UOL",
      Descripcion: "JSON de pago a profesores",
      Categoria: "4. Admisión",
      Tipo: "TextoGrande",
      Permisos: ["Director Ejecutivo Postgrados", "Finanzas"],
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["ventas_por_periodo"] === undefined ||
          cohorte["ventas_por_periodo"] === null ||
          cohorte["ventas_por_periodo"] === ""
        ) {
          return ""
        }            
        return cohorte["ventas_por_periodo"]
      },
    },
    fichafinanciera: {
      Codigo: "fichafinanciera",
      Nombre: "Ficha financiera",
      Descripcion: "Ficha financiera",
      Categoria: "7. Finanzas",
      Tipo: "Link",
      Permisos: ["Director Ejecutivo Postgrados", "Finanzas"],
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        return (
          <Link to={"/fichafinanciera-cohorte/" + cohorte.id}>
            <BiLineChart />
          </Link>
        )
      },
      fieldsRequired: ["id"],
    },
    habilitado: {
      Codigo: "habilitado",
      Nombre: "Habilitado",
      Descripcion: null,
      Tipo: "Booleano",
      Permisos: ["Director de Ventas", "Director Ejecutivo Postgrados"],
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["habilitado"] !== null &&
          cohorte["habilitado"] !== undefined &&
          cohorte["habilitado"]
        ) {
          return <FiCheck />
        } else {
          return <FiX />
        }
      },
      fieldsRequired: ["habilitado"],
    },
    panel_sgc: {
      Codigo: "panel_sgc",
      Nombre: "Panel Gestión",
      Descripcion: "Panel de programa para gestión de la calidad",
      Categoria: "91. Gestión de Calidad",
      Tipo: "Link",
      Permisos: ["Director Ejecutivo Postgrados"],
      fields: ["programa_padre_id"],
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte.programa_padre_id &&
          cohorte.programa_padre_id > 0 &&
          !cohorte.esborrador
        ) {
          return (
            <Link to={"/sgc-panel-programa/" + cohorte.id}>
              <BiLineChart />
            </Link>
          )
        } else {
          return <div>Sin información</div>
        }
      },
      fieldsRequired: ["programa_padre_id"],
    },
    calendario: {
      Codigo: "calendario",
      Nombre: "Calendario Sesiones",
      Descripcion: "Sesiones del programa",
      Categoria: "1. Información general",
      Tipo: "Link",
      Permisos: ["Director Ejecutivo Postgrados", "Director de Ventas"],
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        // Si NO es una charla, no usamos este calendario
        if (cohorte.GradoId !== 8) {
          return <div>N/A</div>
        }
        return (
          <>
            <Link to={"/calendario/" + cohorte.id}>
              <FaCalendar />
            </Link>
          </>
        )
      },
      fieldsRequired: ["id"],
    },
    calendario_detallado: {
      Codigo: "calendario_detallado",
      Nombre: "Calendario Detallado de Sesiones",
      Descripcion: "Sesiones del programa",
      Categoria: "1. Información general",
      Tipo: "Link",
      Permisos: ["Director Ejecutivo Postgrados", "Director de Ventas"],
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (cohorte.esborrador) {
          return <div>N/A</div>
        }
        return (
          <FaCalendar
            onClick={() => {
              window.open("https://mp.uai.cl/app/calendar/build/" + cohorte.id)
            }}
          />
        )
      },
      fieldsRequired: ["id"],
    },
    folleto_automatico: {
      Codigo: "folleto_automatico",
      Nombre: "Folleto Automático",
      Descripcion: "PDF autogenerado con información del MP",
      Categoria: "5. Marketing",
      Tipo: "Link",
      Permisos: [
        "Director Ejecutivo Postgrados",
        "Marketing",
        "Director de Ventas",
      ],
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        return (
          <>
            <Link to={"/folleto-dinamico/" + cohorte.id}>
              <FaRegFilePdf />
            </Link>
          </>
        )
      },
      fieldsRequired: ["id"],
    },
    reporte_encuesta_inicio: {
      Codigo: "reporte_encuesta_inicio",
      Nombre: "Reporte Encuesta inicio",
      Descripcion: "Reporte de la encuesta de inicio de programa.",
      Categoria: "91. Gestión de Calidad",
      Tipo: "Link",
      Permisos: ["Director Ejecutivo Postgrados"],
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["encuesta_inicio"] &&
          cohorte["encuesta_inicio"].length > 5
        ) {
          return (
            <>
              <Link to={"/sgc-encuesta/encuesta_inicio/" + cohorte.id}>
                <BiLineChart />
              </Link>
            </>
          )
        } else {
          return <></>
        }
      },
      fieldsRequired: ["encuesta_inicio"],
    },
    reporte_encuesta_general_satisfaccion: {
      Codigo: "reporte_encuesta_general_satisfaccion",
      Nombre: "Reporte Encuesta General Satisfacción",
      Descripcion: "Reporte de la encuesta general de satisfacción.",
      Categoria: "91. Gestión de Calidad",
      Tipo: "Link",
      Permisos: ["Director Ejecutivo Postgrados"],
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["encuesta_general_satisfaccion"] &&
          cohorte["encuesta_general_satisfaccion"].length > 5
        ) {
          return (
            <>
              <Link
                to={"/sgc-encuesta/encuesta_general_satisfaccion/" + cohorte.id}
              >
                <BiLineChart />
              </Link>
            </>
          )
        } else {
          return <></>
        }
      },
      fieldsRequired: ["encuesta_general_satisfaccion"],
    },
    reporte_encuesta_salida: {
      Codigo: "reporte_encuesta_salida",
      Nombre: "Reporte Encuesta Salida",
      Descripcion: "Reporte de la encuesta de salida de programa.",
      Categoria: "91. Gestión de Calidad",
      Tipo: "Link",
      Permisos: ["Director Ejecutivo Postgrados"],
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["encuesta_salida_programa"] &&
          cohorte["encuesta_salida_programa"].length > 5
        ) {
          return (
            <>
              <Link to={"/sgc-encuesta/encuesta_salida_programa/" + cohorte.id}>
                <BiLineChart />
              </Link>
            </>
          )
        } else {
          return <></>
        }
      },
      fieldsRequired: ["encuesta_salida_programa"],
    },
    reporte_perfil_egreso: {
      Codigo: "reporte_perfil_egreso",
      Nombre: "Reporte Perfil de Egreso",
      Descripcion: "Reporte del perfil de egreso.",
      Categoria: "91. Gestión de Calidad",
      Tipo: "Link",
      Permisos: ["Administrador"],
      display: function (cohorte, periodo, highlight = undefined, usuario) {
        if (
          cohorte["datos_perfil_egreso"] &&
          cohorte["datos_perfil_egreso"].length > 5
        ) {
          return (
            <>
              <Link to={"/perfilegreso/" + cohorte.id}>
                <FaUserGraduate />
              </Link>
            </>
          )
        } else {
          return <></>
        }
      },
      fieldsRequired: ["datos_perfil_egreso"],
    },
  }
  static obligatorios = {
    MBA: {
      Presencial: [],
      Blended: [],
      Online: [],
      Hibrida: [],
    },
    Beca: { Presencial: [], Blended: [], Online: [], Hibrida: [] },
    Certificado: {
      Presencial: [],
      Blended: [],
      Online: [],
      Hibrida: [],
    },
    Charla: {
      Presencial: ["fecha_inicio"],
      Blended: [],
      Online: [],
      Hibrida: [],
    },
    Seminario: { Presencial: [], Blended: [], Online: [], Hibrida: [] },
    Curso: { Presencial: [], Blended: [], Online: [], Hibrida: [] },
    Diplomado: { Presencial: [], Blended: [], Online: [], Hibrida: [] },
    Master: { Presencial: [], Blended: [], Online: [], Hibrida: [] },
    Doctorado: { Presencial: [], Blended: [], Online: [], Hibrida: [] },
  }
}

export default atributos
